import { MutationTree } from 'vuex';
import { State } from './state';
import { TaskViewMutationTypes } from './mutation-types';
import { TaskApiOptions, TaskApiResponseResult } from './types';

export type Mutations<S = State> = {
  [TaskViewMutationTypes.TASK_STORE_SET_LIST](
    state: S,
    payload: {
      taskList: Array<TaskApiResponseResult>;
      totalResultCount: number;
    }
  ): void;
  [TaskViewMutationTypes.TASK_STORE_SET_LIST_ALL](
    state: S,
    payload: {
      taskList: Array<TaskApiResponseResult>;
      totalResultCount: number;
    }
  ): void;
  [TaskViewMutationTypes.TASK_STORE_SET_LOADING](
    state: S,
    isLoading: boolean
  ): void;
  [TaskViewMutationTypes.TASK_STORE_SET_LIST_SETTINGS](
    state: S,
    settings: TaskApiOptions
  ): void;
  [TaskViewMutationTypes.TASK_STORE_SET_LIST_ALL_SETTINGS](
    state: S,
    settings: TaskApiOptions
  ): void;
  [TaskViewMutationTypes.SET_NEW_TASKS_COUNT](state: S, payload: number): void;
  [TaskViewMutationTypes.SET_NEW_TASKS_ALL_COUNT](
    state: S,
    payload: number
  ): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [TaskViewMutationTypes.TASK_STORE_SET_LIST](state: State, payload) {
    state.taskList = payload.taskList;
    state.totalResultCountTaskList = payload.totalResultCount;
  },
  [TaskViewMutationTypes.TASK_STORE_SET_LIST_ALL](state: State, payload) {
    state.taskListAll = payload.taskList;
    state.totalResultCountTaskListAll = payload.totalResultCount;
  },
  [TaskViewMutationTypes.TASK_STORE_SET_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [TaskViewMutationTypes.TASK_STORE_SET_LIST_SETTINGS](state, settings) {
    state.settingsTaskList = settings;
  },
  [TaskViewMutationTypes.TASK_STORE_SET_LIST_ALL_SETTINGS](state, settings) {
    state.settingsTaskListAll = settings;
  },
  [TaskViewMutationTypes.SET_NEW_TASKS_COUNT](state, payload) {
    state.newTasksCount = payload;
  },
  [TaskViewMutationTypes.SET_NEW_TASKS_ALL_COUNT](state, payload) {
    state.newTasksAllCount = payload;
  },
};
